import { useSelector } from 'react-redux';

import { FILTER_LOCATION_NAME } from 'dpl/constants/query_params';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { singleBreederProfileResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';

export function useBreederProfileData() {
  const {
    server: { breederProfileId },
    queryParams: { [FILTER_LOCATION_NAME]: locName }
  } = useSelector(({ server, queryParams }: any) => ({ server, queryParams }));

  const { value: breeder, isFetching: isFetchingBreeder } = useResourceQuery(
    singleBreederProfileResourceDefinition(breederProfileId, { locName })
  );

  const shareMeta = breeder.share_meta;

  return {
    breeder,
    shareMeta,
    isFetchingBreeder
  };
}
